import {createFileRoute} from '@tanstack/react-router'
import {z} from 'zod'
import {SwapZenexDepositStep} from "@/components/wallet/WalletSwapZenex/SwapZenexDepositStep.tsx";


const swapDepSchema = z.object({
  // idmKey: z.string().nonempty(),
  amount: z.string().nonempty(),
  usdc: z.string().nonempty(),
  fromToken: z.string().nonempty(),
  fromNetwork: z.string().nonempty(),
  toToken: z.string().nonempty(),
  toNetwork: z.string().nonempty(),

  fromMetaImg: z.string().optional(),
  fromMetaTokenName: z.string().optional(),
})

export const Route = createFileRoute('/_mainLayout/wallet/swap-zenex/deposit/$idmKey/')({
  component: RouteComponent,
  validateSearch: swapDepSchema,
})

function RouteComponent() {
  const {idmKey} = Route.useParams()
  return <SwapZenexDepositStep idmKey={idmKey} />
  // return <SwapZenexDepositStep idmKey={idmKey} isSwap={true}/>
}
